import { useEffect } from 'react';
import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { i18nService } from '../../services/i18n';
import MemoryFilesPanel from './MemoryFilesPanel';

/** 对话内的个人记忆入口；复用设置面板，关闭窗口不影响当前对话。 */
export default function MemoryFilesDialog({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    window.addEventListener('auth:identityChanging', onClose);
    return () => window.removeEventListener('auth:identityChanging', onClose);
  }, [onClose]);
  return <Dialog open onClose={onClose} className="fixed inset-0 z-[140]">
    <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
    <div className="fixed inset-0 flex items-center justify-center p-3">
      <Dialog.Panel className="w-full max-w-2xl max-h-[90dvh] overflow-y-auto rounded-2xl bg-claude-surface dark:bg-claude-darkSurface p-5 text-claude-text dark:text-claude-darkText shadow-modal">
        <div className="mb-4 flex items-center justify-between gap-3">
          <Dialog.Title className="font-semibold">{i18nService.t('memoryCatalogPersonal')}</Dialog.Title>
          <button type="button" onClick={onClose} aria-label={i18nService.t('close')} className="rounded-lg p-2 hover:bg-black/5 dark:hover:bg-white/5"><XMarkIcon className="h-5 w-5" /></button>
        </div>
        <MemoryFilesPanel />
      </Dialog.Panel>
    </div>
  </Dialog>;
}
